import React, { useEffect, useRef, useState } from "react";
import {
  Image,
  MainContainer,
  MobileScreenContainer,
  ItemName,
  ItemContent,
  ItemPrice,
  Row,
  InputContainer,
  Placeholder,
  Value,
  Column,
  ButtonContainer,
  ButtonFavorite,
  Button,
  PlaceHolderRow,
  Icon,
  ImageContainer,
  Absolute,
  LoaderWrapper,
  ImageWrapper,
  Chevron,
  Heart,
  ChipInLoadBar,
  ChippedIn,
  ChipInContainer,
  ChipInRow,
  ChipInPrice,
  ChipInText,
} from "./MobileAppPage.styles";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { priceFormatter } from "../../utils/utils";

import { getCurrencySymbol } from "../../utils/constants";
import MediaSlider from "../../components/MediaSlider/MediaSlider";
import Dots from "../../components/Dots/Dots";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectedGetItemLoading,
  selectedItem,
  setChipIn,
} from "../../store/slices/item/itemSlice";
import MiniLoader from "../../components/MiniLoader/MiniLoader";
import { getItemUnauthorized } from "../../store/slices/item/asyncThunks";
import DownloadAppModal from "../../components/DownloadAppModal/DownloadAppModal";
import { useSwipeable } from "react-swipeable";
import AppLoader from "../../components/AppLoader";
import ChipInModal from "../../components/ChipInModal/ChipInModal";
import { toast } from "react-toastify";

const MobileAppItemDetailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const openModal = useRef();
  const chipInModal = useRef();
  const { t } = useTranslation();
  const { id } = useParams();
  const [activeIndex, setActiveIndex] = useState(0);
  const item = useSelector(selectedItem);
  const loading = useSelector(selectedGetItemLoading);

  const [chipInValue, setChipInValue] = useState(50);

  useEffect(() => {
    document.documentElement.style.background = "#fff";
    dispatch(getItemUnauthorized(id));
  }, [dispatch, id]);

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setActiveIndex((prevIndex) =>
        prevIndex === item?.photos.length - 1 ? 0 : prevIndex + 1
      );
    },
    onSwipedRight: () => {
      setActiveIndex((prevIndex) =>
        prevIndex === 0 ? item?.photos.length - 1 : prevIndex - 1
      );
    },
  });
  const priceItem = priceFormatter(+item?.price, true, 15);
  const remainingPrice = +priceItem - +item?.paidChipIn;
  const chipInPercentage = (+item?.paidChipIn / +priceItem) * 100;

  return (
    <MainContainer>
      <DownloadAppModal modalRef={openModal} />
      <ChipInModal
        modalRef={chipInModal}
        maxAmount={priceItem}
        value={chipInValue}
        setValue={setChipInValue}
        item={item}
        remainingPrice={remainingPrice}
        onChipIn={() => {
          if (
            remainingPrice <= 50
              ? +chipInValue === +remainingPrice.toFixed(2)
              : +chipInValue >= 50 && +chipInValue <= +remainingPrice.toFixed(2)
          ) {
            dispatch(setChipIn({ amount: +chipInValue }));
            navigate(`/mobile-app/checkout/${id}`);
          } else {
            toast.error(
              remainingPrice >= 50 && +chipInValue < 50
                ? t("Amount must be at least 50 SAR")
                : t("Incorrect chip in amount.")
            );
          }
        }}
      />

      <MobileScreenContainer>
        {!loading ? (
          <>
            <ImageContainer>
              <Icon onClick={() => navigate(-1)}>
                <Chevron />
              </Icon>
              {item?.photos?.length > 0 ? (
                item?.photos?.length > 1 ? (
                  <ImageWrapper
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                    {...handlers}
                  >
                    <MediaSlider
                      style={{
                        objectFit: item.productId ? "contain" : "cover",
                      }}
                      mobileApp
                      hideArrows
                      pictures={item?.photos}
                      activeIndex={activeIndex}
                      onSlideChange={setActiveIndex}
                    />
                    <Absolute>
                      <Dots
                        total={item?.photos.length}
                        activeIndex={activeIndex}
                        onDotClick={handleDotClick}
                      />
                    </Absolute>
                  </ImageWrapper>
                ) : (
                  <ImageWrapper>
                    <Image
                      src={item?.photos[0].url}
                      style={{
                        objectFit: item.productId ? "contain" : "cover",
                      }}
                    />
                  </ImageWrapper>
                )
              ) : (
                <AppLoader />
              )}
            </ImageContainer>
            <ItemContent>
              <Column>
                <Row>
                  <ItemName>{item?.name}</ItemName>
                  {item.isBought ? (
                    <ItemPrice $isBought>
                      {priceItem} {getCurrencySymbol(item?.currency)}
                    </ItemPrice>
                  ) : item.isChipInItem ? (
                    <ItemPrice $isBought>
                      {priceItem} {getCurrencySymbol(item?.currency)}
                    </ItemPrice>
                  ) : (
                    <ItemPrice>
                      {priceItem} {getCurrencySymbol(item?.currency)}
                    </ItemPrice>
                  )}
                </Row>
                {item?.isChipInItem && (
                  <ChipInContainer>
                    <ChipInRow>
                      <ChipInText>{t("contributed")}:</ChipInText>
                      <ChipInPrice>
                        {priceFormatter(+item?.paidChipIn)}{" "}
                        {getCurrencySymbol(item?.currency ?? "sar")}
                      </ChipInPrice>
                    </ChipInRow>
                    <ChipInRow>
                      <ChipInText>{t("remaining")}:</ChipInText>
                      <ChipInPrice $red>
                        {priceFormatter(remainingPrice)}{" "}
                        {getCurrencySymbol(item?.currency ?? "sar")}
                      </ChipInPrice>
                    </ChipInRow>
                    {chipInPercentage === 0 ? (
                      <ChipInLoadBar $center>
                        {chipInPercentage.toFixed(0)}%
                      </ChipInLoadBar>
                    ) : (
                      <ChipInLoadBar $center>
                        <ChippedIn
                          style={{
                            width: `${chipInPercentage}%`,
                          }}
                        >
                          {chipInPercentage.toFixed(0)}%
                        </ChippedIn>
                      </ChipInLoadBar>
                    )}

                    {/* <ChippedInUsers>
                    {chippedUsers.map((user) => (
                      <ChippedInUser key={user.id}>
                        <ChipInSmallRow>
                          <ChipInProfilePhoto src={user.profilePhoto} />
                          <ChippedInName>{user.name}</ChippedInName>
                        </ChipInSmallRow>
                        <ChippedInValue>
                          {getCurrencySymbol("sar")} {user.chip}
                        </ChippedInValue>
                      </ChippedInUser>
                    ))}
                  </ChippedInUsers> */}
                  </ChipInContainer>
                )}

                {item?.description && (
                  <InputContainer>
                    <PlaceHolderRow>
                      <Placeholder>📃</Placeholder>
                      <Placeholder>{t("description")}</Placeholder>
                    </PlaceHolderRow>
                    <Value>{item.description}</Value>
                  </InputContainer>
                )}
                {item?.categories?.length > 0 && (
                  <InputContainer>
                    <PlaceHolderRow>
                      <Placeholder>🛍</Placeholder>
                      <Placeholder>{t("category")}</Placeholder>
                    </PlaceHolderRow>
                    {item?.categories.map((category) => (
                      <Value>{category.name}</Value>
                    ))}
                  </InputContainer>
                )}
                {item?.url && (
                  <InputContainer>
                    <PlaceHolderRow>
                      <Placeholder>💻</Placeholder>
                      <Placeholder>{t("url")}</Placeholder>
                    </PlaceHolderRow>
                    <Value>{item?.url}</Value>
                  </InputContainer>
                )}
                {item?.location && (
                  <InputContainer>
                    <PlaceHolderRow>
                      <Placeholder>📍</Placeholder>
                      <Placeholder>{t("gift-location")}</Placeholder>
                    </PlaceHolderRow>
                    <Value>{item?.location.name}</Value>
                  </InputContainer>
                )}
              </Column>
              {item?.isChipInItem ? (
                <ButtonContainer>
                  <ButtonFavorite onClick={() => openModal.current.show()}>
                    <Heart />
                  </ButtonFavorite>
                  <Button
                    onClick={() => {
                      chipInModal.current.show();
                    }}
                  >
                    {t("chip-in")}
                  </Button>
                </ButtonContainer>
              ) : (
                item?.buyable &&
                !item?.isBought && (
                  <ButtonContainer>
                    <ButtonFavorite onClick={() => openModal.current.show()}>
                      <Heart />
                    </ButtonFavorite>
                    <Button
                      onClick={() => {
                        navigate(`/mobile-app/checkout/${id}`);
                      }}
                    >
                      {t("buy-now")}
                    </Button>
                  </ButtonContainer>
                )
              )}
            </ItemContent>
          </>
        ) : (
          <LoaderWrapper>
            <MiniLoader />
          </LoaderWrapper>
        )}
      </MobileScreenContainer>
    </MainContainer>
  );
};

export default MobileAppItemDetailPage;
